module.exports = global["$"] = require("-!/var/www/html/presta-fastest-plus/themes/codazon-fastestplus-fashion/_dev/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 2
// module chunks = 0